import { Component, Input, ViewChild, ChangeDetectionStrategy } from "@angular/core";
import { UntypedFormControl } from "@angular/forms";
import { DonorService } from "../services/donor.service";
import { IPlannedGivingContactModel } from "../domain/types";
import { PlannedGivingComponent } from "../planned-giving/planned-giving.component";

@Component({
    selector: "app-honor",
    templateUrl: "./honor.component.html",
    styleUrls: ["./honor.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HonorComponent {

  @Input() honorModel: any;
  @Input() giftNotify: any;
  @Input() plannedGiving: IPlannedGivingContactModel;
  @Input() donorEditCommon: DonorService;
  @Input() form: any;
  @ViewChild("inhonorname") inhonorname: UntypedFormControl;
  @ViewChild("notifyname") notifyname: UntypedFormControl;
  @ViewChild("notifyemail") notifyemail: UntypedFormControl;
  @ViewChild("notifytelephone") notifytelephone: UntypedFormControl;
  @ViewChild("postalCodeNotify") postalCodeNotify: UntypedFormControl;
  @ViewChild("notifyaddress1") notifyaddress1: UntypedFormControl;
  @ViewChild("notifyaddress2") notifyaddress2: UntypedFormControl;
  @ViewChild("notifycity") notifycity: UntypedFormControl;
  @ViewChild("notifystateId") notifystateId: UntypedFormControl;
  @ViewChild(PlannedGivingComponent) plannedGivingComponent: PlannedGivingComponent;

  accountNameChanged = false;
  lookingUpZip = false;

  notifySomeone = false;
  inMemoryHonorOf = false;
  inMemory = false;
  inHonor = true;

  constructor() {}

  get hasErrors(){
    if(this.inhonorname && this.inhonorname.invalid){
      return true;
    }
    if(this.notifyname && this.notifyname.invalid){
      return true;
    }
    if(this.notifyemail && this.notifyemail.invalid){
      return true;
    }
    if(this.notifytelephone && this.notifytelephone.invalid){
      return true;
    }
    if(this.postalCodeNotify && this.postalCodeNotify.invalid){
      return true;
    }
    if(this.notifyaddress1 && this.notifyaddress1.invalid){
      return true;
    }
    if(this.notifyaddress2 && this.notifyaddress2.invalid){
      return true;
    }
    if(this.notifycity && this.notifycity.invalid){
      return true;
    }
    if(this.notifystateId && this.notifystateId.invalid){
      return true;
    }
    if (this.plannedGivingComponent && this.plannedGivingComponent.hasErrors) {
      return true;
    }
    return false;
  }

  showError(ctl: UntypedFormControl){
    return this.form && ctl && (this.form.submitted || ctl.touched || ctl.dirty);
  }

  touchPlannedGivingIfInvalid() {
    this.plannedGivingComponent?.touchInvalidControls();
  }
}
